import { cssMap } from '@atlaskit/css';
import CloseIcon from '@atlaskit/icon/core/cross';
import { Anchor, Box, Inline, Pressable, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { useMessageInstanceEvent } from '@post-office/message-instance-event-frontend-client';
import { useMessageEvent } from '@post-office/message-lifecycle';
// @ts-expect-error: 'React' is declared but its value is never read
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { type JSX } from 'react/jsx-runtime';

const styles = cssMap({
	pressable: {
		color: token('color.text.inverse'),
		cursor: 'pointer',
		textDecoration: 'underline',

		'&:hover': {
			color: token('color.text.inverse'),
			textDecoration: 'underline',
		},
		'&:active': {
			textDecoration: 'none',
		},
	},
	onClickBackgroundColor: {
		backgroundColor: token('color.background.neutral.bold'),
	},
});

const ComingSoonMessage = () => (
	<FormattedMessage
		id="post-office.placement.jira-top-banner.primary-message"
		description="Coming soon message for the Jira top banner"
		defaultMessage="As we roll out 'work' as the new term for items tracked in Jira, you may still see 'issue' in some areas."
	/>
);

const ReadMoreLink = () => (
	<Anchor
		href="https://community.atlassian.com/t5/Jira-articles/It-s-here-Work-is-the-new-collective-term-for-all-items-you/ba-p/2954892"
		rel="noopener noreferrer"
		target="_blank"
		xcss={styles.pressable}
	>
		<FormattedMessage
			id="st-office.placement.jira-top-banner.primary-cta-text"
			description="Read more link for the Jira top banner"
			defaultMessage="Read about this terminology change"
		/>
	</Anchor>
);

export const TopBannerMessage = (): JSX.Element => {
	const { messageDismissed } = useMessageEvent();
	const { messageInstanceClicked } = useMessageInstanceEvent();

	const onClickDismiss = useCallback(() => {
		void messageDismissed();
		void messageInstanceClicked({
			messageEventType: 'clicked',
			clickedElement: {
				clickIdentifier: 'dismiss',
				clickedElement: 'button',
				buttonType: 'primary',
			},
			action: {
				actionType: 'dismiss',
			},
			additionalMetadataFromFrontend: {},
		});
	}, [messageDismissed, messageInstanceClicked]);

	return (
		<Box
			backgroundColor="color.background.neutral.bold"
			padding="space.200"
			testId="jira-top-banner"
		>
			<Inline spread="space-between">
				<Text color="color.text.inverse">
					<ComingSoonMessage />
					&nbsp;
					<ReadMoreLink />
				</Text>
				<Pressable xcss={styles.onClickBackgroundColor} onClick={onClickDismiss}>
					<CloseIcon color={token('color.text.inverse')} label="Dismiss" />
				</Pressable>
			</Inline>
		</Box>
	);
};
